import { getCurrentKeyboard, getCurrentShortcutsList, setCurrentShortcutsList } from "./software";

// **************************************************************************************************************
// keyboard shortcuts
// **************************************************************************************************************
        import defaultsShortCuts from './defaultshortcuts.json';
        const defaultsShortCutsOld =

        {
            applications : 
            [
                // ******************************* PLAYER
                {
                    name:"player",
                    fr:"Player", 
                    en:"Player",
                    unique: true,
                    subfamily: 
                    [
                        {
                            fr: "Contrôle du Player",
                            en: "Player Controls",
                            shortcuts:
                            [
                                {key:"PLAY", fr:"Play/Stop",en:"Play/Stop", win:{code: "ArrowUp", shift:false,ctrl:false,alt:true}, mac:{code: "ArrowUp", shift:false,ctrl:false,alt:true}},

                                {key:"STOP", fr:"Stop",en:"Play", win: {code: "ArrowDown", shift:false,ctrl:false,alt:true}},
                                {key:"NEXTF", fr:"Avance une image",en:"Next Frame", win: {code: "ArrowRight",shift:false,ctrl:false,alt:true}},
                                {key: "PREVF", fr:"Recul une image",en:"Previous Frame",win:{code: "ArrowLeft",shift:false,ctrl:false,alt:true}},
                                {key: "NEXT1",fr:"Avance 1s",en:"Go Forward 1s",win:{code: "PageDown",shift:false,ctrl:false,alt:true}},
                                {key: "PREV1", fr:"Recule 1s",en:"Go Back 1s",win:{code: "PageUp",shift:false,ctrl:false,alt:true}},
                                {key: "NEXT20",fr:"Avance nombre d'images prédéfinies",en:"Advance by a preset number of frames",win:{code: "ArrowRight",shift:false,ctrl:true,alt:true}},
                                {key: "PREV20", fr:"Recule nombre d'images prédéfinies",en:"Step back number of preset images",win:{code: "ArrowLeft",shift:false,ctrl:true,alt:true}},
                                //{key: "TIMELINEMODE", fr:"Mode d'affichage de la timeline",en:"Timeline display mode",win:{code: "R",shift:true,ctrl:true,alt:false}},
                                {key: "ADDCP", fr:"Ajoute/Supprime un changement de plan",en:"Add/remove shot",win:{code: "k",shift:false,ctrl:false,alt:true}},

                                {key: "PLAYERPREVIOUSCP", fr:"Aller au changement de plan précédent",en:"Go to previous shot",win:{code: "F9",shift:false,ctrl:false,alt:true}},
                                {key: "PLAYERNEXTCP", fr:"Aller au prochain changement de plan",en:"Go to next shot",win:{code: "F10",shift:false,ctrl:false,alt:true}},
                            ]
                        },
                    ],
                },
                // ******************************* TRANSCRIPTION
                {
                    name: "transcription",
                    fr: "Transcription",
                    en: "Transcription",
                    unique: false,
                    subfamily: 
                    [
                        {
                            fr: "Saisie des times codes",
                            en: "Time code input",
                            shortcuts:
                            [
                              { key: 'SETTIMECODEINFROMCURRENTSUBTITLETOVIDEO', fr: "Cale la vidéo au time code IN du sous-titre courant", en: 'Sets video to IN time code of current subtitle', win: { code: 'Enter', shift: false, ctrl: false, alt: true } },
                              { key: 'SETTIMECODEOUTFROMCURRENTSUBTITLETOVIDEO', fr: "Cale la vidéo au time code OUT du sous-titre courant", en: 'Sets video to OUT time code of current subtitle', win: { code: 'Enter', shift: false, ctrl: true, alt: false }},
                            ]
                        },
                        {
                            fr: "Déplacement dans le texte",
                            en: "movements in the text",
                            shortcuts:
                            [
                                { key: 'LEFT', fr: 'Curseur vers la gauche', en: 'Cursor Left', win:{code: 'ArrowLeft', shift: false, ctrl: false, alt: false}},
                                { key: 'RIGHT', fr: 'Curseur vers la droite', en: 'Cursor Right', win:{code: 'ArrowRight', shift: false, ctrl: false, alt: false}},
                                { key: 'UP', fr: 'Curseur vers le haut', en: 'Cursor Up', win:{code: 'ArrowUp', shift: false, ctrl: false, alt: false}},
                                { key: 'DOWN', fr: 'Curseur vers le bas', en: 'Cursor Down', win:{code: 'ArrowDown', shift: false, ctrl: false, alt: false}},

                                { key: 'NEXTWORD', fr: 'Mot suivant', en: 'Next Word', win:{code: 'ArrowRight', shift: false, ctrl: true, alt: false}},
                                { key: 'PREVIOUSWORD', fr: 'Mot précédent', en: 'Previous word', win:{code: 'ArrowLeft', shift: false, ctrl: true, alt: false}},


                                { key: 'HOME', fr: 'Début du texte', en: 'Text Start', win:{code: 'Home', shift: false, ctrl: true, alt: false}},
                                { key: 'END', fr: 'Fin du texte', en: 'Text End', win:{code: 'End', shift: false, ctrl: true, alt: false}},

                                { key: 'PGUP', fr: 'Page précédente', en: 'Previous page', win:{code: 'PageUp', shift: false, ctrl: false, alt: false}},
                                { key: 'PGDOWN', fr: 'Page suivante', en: 'Next page', win:{code: 'PageDown', shift: false, ctrl: false, alt: false}},

                                { key: 'STARTSENTENCE', fr: 'Début de la phrase', en: 'Start of sentence', win:{code: 'Home', shift: false, ctrl: false, alt: false}},
                                { key: 'ENDSENTENCE', fr: 'Fin de la phrase', en: 'End of sentence', win:{code: 'End', shift: false, ctrl:false, alt: false}},

                                { key: 'STARTWORD', fr: 'Début du mot', en: 'Start of word', win: { code: 'ArrowUp', shift: false, ctrl: true, alt: false }},
                                { key: 'ENDWORD', fr: 'Fin du mot', en: 'End of word',win: { code: 'ArrowDown', shift: false, ctrl: true, alt: false }},

                                 { key: 'GOTONEXTDIALOGUE', fr: 'Aller au prochain dialogue du speaker', en: `Go to speaker's next dialogue`,win: { code: 'ArrowDown', shift: true, ctrl: false, alt: false }},
                                 { key: 'GOTOPREVIOUSDIALOGUE', fr: 'Aller au précédent dialogue du speaker', en: `Go to speaker's previous dialogue`,win: { code: 'ArrowUp', shift: true, ctrl: false, alt: false }},


                            ],
                        },
                        {
                            fr: "Edition du texte",
                            en: "Text Edition",
                            shortcuts:
                            [
                                { key: 'BACKSPACE', fr: 'Effacement Arrière', en: 'Backspace', win:{code: 'Backspace', shift: false, ctrl: false, alt: false}},
                                { key: 'DELETE', fr: 'Supprimer caractère', en: 'Delete', win:{code: 'Delete', shift: false, ctrl: false, alt: false}},

                                { key: 'COPY', fr: 'Copier', en: 'Copy', win:{code: 'c', shift: false, ctrl: true, alt: false}},
                                { key: 'PASTE', fr: 'Coller', en: 'Paste', win:{code: 'v', shift: false, ctrl: true, alt: false}},
                                { key: 'CUT', fr: 'Couper', en: 'Cut', win:{code: 'x', shift: false, ctrl: true, alt: false}},
                                { key: 'UNDO', fr: 'Annuler', en: 'Undo', win:{code: 'z', shift: false, ctrl: true, alt: false}},
                                { key: 'REDO', fr: 'Refaire', en: 'Redo', win:{code: 'y', shift: false, ctrl: true, alt: false}},

                                { key: 'DELETEWORD', fr: 'Supprimer un mot', en: 'Delete Word', win:{code: 'Delete', shift: false, ctrl: true, alt: false}},
                                { key: 'DELETELINE', fr: 'Supprimer la ligne', en: 'Delete Line', win:{code: 'o', shift: false, ctrl: true, alt: false}},


                                { key: 'ENTER',  fr: 'Entrée',  en: 'Enter', win: { code: 'Enter', shift: false, ctrl: false, alt: false}},
                                { key: 'UNSECABLE',fr: 'Espace insécable', en: 'Unsecable space', win: { code: ' ',shift: true, ctrl: true, alt: false}},

                                { key: 'DELETEWORDSUNTIL',fr: "Suppression jusqu'au mot", en: 'Deletion until the word', win: { code: 'F12', shift: false, ctrl: false, alt: false }},
                                { key: 'DELETEUNSECABLE', fr: "Supprime l'espace insécable", en: 'Delete unsecable space', win: { code: '<', shift: false, ctrl: true, alt: true}},

                                { key: 'GROUPBYUNSECABLESPACEWITHNEXTWORD', fr: 'Regroupe le mot en cours avec le mot suivant par un espace insécable',en: 'Group the current word with the next word by unsecable space', win: { code: 'i', shift: false, ctrl: true, alt: false}},
                                { key: 'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD', fr: 'Regroupe le mot en cours avec le mot précédent par un espace insécable', en: 'Group the current word with the previous word by unsecable space', win: { code: 'i', shift: false, ctrl: false, alt: true }},
                            ]
                        },

                        {
                            fr: "Corrections rapides",
                            en: "Quick Fix",
                            shortcuts:
                            [

                                { key: 'TAB',fr: 'Erreurs communes de transcription', en: 'Common transcription errors',win: { code: 'Tab',shift: false, ctrl: false, alt: false }},
                                { key: 'ADDHYPHEN',fr: 'Ajouter un tiret',en: 'Add a hyphen', win: { code: 'F1',shift: false, ctrl: true,alt: false}},
                                { key: 'GROUPWORDSWITHOUTSPACE',fr: 'Regroupe les mots sans espace',en: 'Group the words without space',win: { code: 'g',shift: false, ctrl: true, alt: false }},
                                { key: 'CONVERSIONTOINITIAL',  fr: 'Transformation en initiales', en: 'Conversion to initial',  win: { code: 'j', shift: false, ctrl: true, alt: false }},
                                { key: 'CONVERSIONTOINITIALWITHOUTSPACE', fr: 'Transformation en initiales sans espace', en: 'Conversion to initial without space', win: { code: 'j', shift: false, ctrl: true, alt: true }},
                                { key: 'UPPERCASEORLOWERCASEONFIRSTLETTER', fr: 'Majuscule/minuscule sur la première lettre',en: 'Upper/lower case on first letter', win: { code: 'q', shift: false, ctrl: true, alt: false }},
                                { key: 'UPPERCASEORLOWERCASEONSECONDLETTER', fr: 'Majuscule/minuscule sur la deuxième lettre', en: 'Upper/lower case on second letter', win: { code: 'Q', shift: true, ctrl: true, alt: false }},
                                { key: 'UPPERCASEORLOWERCASEWITHAPOSTROPHEORPERIOD', fr: 'Mettre une majuscule ou une minuscule aprÃ¨s une apostrophe ou un point', en: 'Upper or lower case after an apostrophe or a period', win: { code: 'Q', shift: true, ctrl: true, alt: true }},
                                { key: 'UPPERCASEORLOWERCASEWITHDASH', fr: 'Majuscule/minuscule mot avec un tiret', en: 'Upper/lower case on word with dash', win: { code: 'w', shift: false, ctrl: false, alt: true }},
                                { key: 'UPPERCASEONWORD', fr: 'Mot en majuscule', en: 'Uppercase on word', win: { code: 'u', shift: false, ctrl: true, alt: false }},
                                { key: 'LOWERCASEONWORD', fr: 'Mot en minuscule', en: 'Lowercase on word', win: { code: 'L', shift: true, ctrl: true, alt: false }},
                                { key: 'UPPERCASEORLOWERCASEONSENTENCE', fr: 'Phrase entière en majuscule ou en minuscule', en: 'Uppercase or lowercase on sentence', win: { code: 'U', shift: true, ctrl: true, alt: false }},
                                { key: 'RETURNTOLINEWITHHYPHEN', fr: 'Retour à la ligne avec tiret', en: 'Return to line with hyphen', win: { code: '-', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDPERIOD', fr: 'Ajoute un point à la fin du mot',  en: 'Add a period at the end of the word', win: { code: 'p', shift: false, ctrl: true, alt: false }},
                                { key: 'ADDPERIODANDNEWLINE', fr: 'Ajoute un point à la fin du mot et nouvelle ligne', en: 'Add a period at the end of the word and new line', win: { code: 'P', shift: true, ctrl: true, alt: false }},
                                { key: 'ADDQUOTES', fr: 'Ajoute des guillemets', en: 'Add quotes', win: { code: 'm', shift: false, ctrl: true, alt: false }},
                                { key: 'ADDTWOAPOSTROPHES', fr: 'Ajoute des apostrophes au début et à la fin du mot', en: 'Add apostrophes at the beginning and end of the word', win: { code: 'm', shift: false, ctrl: true, alt: true}},
                                
                                { key: 'ADDONEAPOSTROPHE', fr: 'Ajoute un apostrophe au mot', en: 'Add one apostrophe to the word', win: { code: '4', shift: true, ctrl: true, alt: false }},
                                { key: 'ADDORREMOVESLETTER', fr: 'Ajoute ou enlève un s', en: 'Add or remove s letter',  win: { code: 's', shift: false, ctrl: true, alt: true }},
                                { key: 'ADDORREMOVENTLETTER',  fr: "Ajoute ou enlève un 'nt'", en: "Add or remove 'nt' letters", win: { code: 't', shift: false, ctrl: true, alt: true}},
                                { key: 'INVERTPERIODEANDCOMMA', fr: 'Inverse le point et la virgule', en: 'Invert the period and comma', win: { code: ';', shift: false, ctrl: false,  alt: true }},
                                { key: 'INVERTA', fr: 'Inverse le a et à', en: 'Invert the a and à', win: { code: 'a', shift: false, ctrl: false, alt: true }},
                                { key: 'HYPHENATETWOWORDS', fr: 'Regroupe deux mots par un tiret', en: 'Hyphenate two words', win: { code: 'd', shift: false, ctrl: true,alt: false }},
                                { key: 'REPLACEHYPHENWITHSPACE', fr: 'Remplace le tiret dans le mot par un espace', en: 'Replace the hyphen in the word with a space', win: { code: 'S', shift: true, ctrl: true, alt: false }},
                                { key: 'REPLACEHYPHENWITHUNSECABLESPACE', fr: 'Remplace le tiret dans le mot par un espace insécable', en: 'Replace the hyphen in the word with a unsecable space',win: { code: 'I', shift: true, ctrl: true, alt: false }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_C',fr: "Ajoute ou supprime la lettre c'",en: "Add or remove c' letter", win: { code: 'c',  shift: false, ctrl: false, alt: true}},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_C', fr: "Ajoute ou supprime l'apostrophe à la lettre c", en: 'Add or remove the apostrophe from the c letter', win: { code: 'C', shift: true, ctrl: false, alt: true}},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_D', fr: "Ajoute ou supprime la lettre d'", en: "Add or remove d' letter", win: { code: 'd', shift: false, ctrl: false, alt: true }},
                                
                                  // Ne marche pas, pourquoi ???
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_D', fr: "Ajoute ou supprime l'apostrophe à la lettre d", en: 'Add or remove the apostrophe from the d letter', win: { code: 'D', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_J', fr: "Ajoute ou supprime la lettre j'",en: "Add or remove j' letter", win: { code: 'j', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_J', fr: "Ajoute ou supprime l'apostrophe à la lettre j",en: 'Add or remove the apostrophe from the j letter', win: { code: 'J', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_L', fr: "Ajoute ou supprime la lettre l'", en: "Add or remove l' letter",win: { code: 'l', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_L', fr: "Ajoute ou supprime l'apostrophe à la lettre l", en: 'Add or remove the apostrophe from the l letter',win: { code: 'L', shift: true, ctrl: false, alt: true}},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_M', fr: "Ajoute ou supprime la lettre m'", en: "Add or remove m' letter", win: { code: 'm', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_M', fr: "Ajoute ou supprime l'apostrophe à la lettre m", en: 'Add or remove the apostrophe from the m letter', win: { code: 'M', shift: true, ctrl: false,  alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_N', fr: "Ajoute ou supprime la lettre n'", en: "Add or remove n' letter", win: { code: 'n', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_N', fr: "Ajoute ou supprime l'apostrophe à la lettre n", en: 'Add or remove the apostrophe from the n letter', win: { code: 'N', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_Q', fr: "Ajoute ou supprime la lettre qu'", en: "Add or remove qu' letter", win: { code: 'q', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_Q', fr: "Ajoute ou supprime l'apostrophe à la lettre qu", en: 'Add or remove the apostrophe from the qu letter', win: { code: 'Q', shift: true, ctrl: false, alt: true}},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_S', fr: "Ajoute ou supprime la lettre s'", en: "Add or remove s' letter", win: { code: 's', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_S', fr: "Ajoute ou supprime l'apostrophe à la lettre s", en: 'Add or remove the apostrophe from the s letter', win: { code: 'S', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_T', fr: "Ajoute ou supprime la lettre T'", en: "Add or remove t' letter", win: { code: 't', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_T', fr: "Ajoute ou supprime l'apostrophe à la lettre t", en: 'Add or remove the apostrophe from the t letter', win: { code: 'T', shift: true, ctrl: false, alt: true }},
                                { key: 'REPLACE_E', fr: "Remplace 'er' => 'é'", en: "Replace 'er' => 'é'",  win: { code: 'e',  shift: false,  ctrl: false, alt: true }},
                                { key: 'REPLACE_Z', fr: "Remplace 'r' => 'z'",  en: "Replace 'r' => 'z'", win: { code: 'z', shift: false, ctrl: false, alt: true }},
                                { key: 'REPLACE_R', fr: "Remplace 'ez' => 'er'",en: "Replace 'ez' => 'er'", win: { code: 'r', shift: false, ctrl: false, alt: true }},
                                { key: 'REPLACE_T', fr: "Remplace 'é' => 'ait' => 'aient'", en: "Replace 'é' => 'ait' => 'aient'",  win: { code: 'T',  shift: true, ctrl: true,  alt: true }},
                                { key: 'ADDORREMOVELETOWORD',  fr: "Ajoute ou enlève à la fin du mot 'le'", en: "Add or remove at the end of the word 'le'", win: { code: 'l',shift: false, ctrl: true, alt: false }},

                            ]
                        },

                        {
                            fr: "Sélection des mots",
                            en: "Words selection",
                            shortcuts:
                            [
                                { key: 'SELECTLEFT', fr: 'Sélectionner vers la gauche', en: 'Select to Left', win:{code: 'ArrowLeft', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTRIGHT', fr: 'Sélectionner vers la droite', en: 'Select to Right', win:{code: 'ArrowRight', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTUP', fr: 'Sélectionner vers le haut', en: 'Select to Up', win:{code: 'ArrowUp', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTDOWN', fr: 'Sélectionner vers le bas', en: 'Select to Down', win:{code: 'ArrowDown', shift: true, ctrl: true, alt: false}},

                                { key: 'SELECTA', fr: 'Sélectionner un mot, la ligne ou le texte et copie.', en: 'Select wotd,line or full text and copy', win:{code: 'a', shift: false, ctrl: true, alt: false}},

                                { key: 'SELECTUPSENTENCE', fr: "Sélectionner jusqu'au début de la phrase", en: 'Select up to the beginning of the sentence', win:{code: 'Home', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTDOWNSENTENCE', fr: "Sélectionner jsuqu'à la fin de la phrase", en: 'Select up to the end of the sentence', win:{code: 'End', shift: true, ctrl: true, alt: false}},

                                { key: 'SELECTLETTERBYLETTERONRIGHT', fr: 'Sélectionner lettre par lettre à droite', en: 'Select letter by letter on the right', win:{code: 'ArrowRight', shift:true, ctrl:false, alt:false}},
                                { key: 'SELECTLETTERBYLETTERONLEFT', fr: 'Sélectionner lettre par lettre à gauche', en: 'Select letter by letter on the left', win:{code: 'ArrowLeft', shift:true, ctrl:false, alt:false}}

                            ],
                        },

                        {
                            fr: "Couleurs",
                            en: "Colors",
                            shortcuts: 
                            [
                                { key: 'BLUE', fr: 'Bleu', en: 'Blue', win:{code: 'F1', shift: true, ctrl: false, alt: false}},
                                { key: 'GREEN', fr: 'Vert', en: 'Green', win:{code: 'F2', shift: true, ctrl: false, alt: false}},
                                { key: 'CYAN', fr: 'Cyan', en: 'Cyan', win:{code: 'F3', shift: true, ctrl: false, alt: false}},
                                { key: 'RED', fr: 'Rouge', en: 'Red', win:{code: 'F4', shift: true, ctrl: false, alt: false}},
                                { key: 'MAGENTA', fr: 'Magenta', en: 'Magenta', win:{code: 'F5', shift: true, ctrl: false, alt: false}},
                                { key: 'YELLOW', fr: 'Jaune', en: 'Yellow', win:{code: 'F6', shift: true, ctrl: false, alt: false}},
                                { key: 'WHITE', fr: 'Blanc', en: 'White', win:{code: 'F7', shift: true, ctrl: false, alt: false}},
                            ]
                        },

                        {
                            fr: "Orthographe/Grammaire",
                            en: "Spelling/Grammar",
                            shortcuts:
                            [
                                { key: 'WORDCHECKER', fr: 'Verifier Orthographe/Grammaire', en: 'Check Spelling/Grammar', win:{code: 'F8', shift: true, ctrl: false, alt: false}},
                                { key: 'GOTOWORDINERROR', fr: 'Aller au prochain mot en erreur', en: 'Go to the next word in error', win:{code: 'E', shift: true, ctrl: true, alt: false}},
                            ]
                        },


                        {
                            fr: "Divers",
                            en: "Miscellianous",
                            shortcuts:
                            [
                                { key: 'SAVE', fr: 'Sauvegarder', en: 'Save', win:{code: 's', shift: false, ctrl: true, alt: false}},

                                { key: 'CHECKWORD', fr: 'Marquer le mot', en: 'Mark word', win:{code: '&', shift: false, ctrl: true, alt: false}},
                                { key: 'NEWST', fr: 'Forcer nouvelle ligne', en: 'Force new line', win:{code: '*', shift: false, ctrl: true, alt: false}},

                                { key: 'LOCK',fr: 'Vérrouiller ou déverrouiller le scroll', en: 'Lock or unlock scroll', win: { code: 'b', shift: false, ctrl: true, alt: false,}},
                                { key: 'PREVIOUSPOSITION',fr: 'position précédente', en: 'Previous position', win: { code: 'p',shift: false,ctrl: false,alt: true, }},

                                { key: 'CHANGETRANSCRIPTION',fr: 'Changer de transcription (originale/modifiée)',en: 'Change transcription (original/corrected', win: { code: 'Tab', shift: true,ctrl: false, alt: false}},


                                { key: 'SEARCH', fr: 'Rechercher', en: 'Search', win:{code: 'f', shift: false, ctrl: true, alt: false}},
                                { key: 'REPLACE', fr: 'Remplacer', en: 'Replace', win:{code: 'h', shift: false, ctrl: true, alt: false}},

                                { key: 'NEXTMATCH', fr: 'Correspondance suivante', en: 'Next match', win:{code: 'F3', shift: false, ctrl: false, alt: false}},
                                { key: 'PREVIOUSMATCH', fr: 'Correspondance précédente', en: 'Previous match', win:{code: 'F4', shift: false, ctrl: false, alt: false}},

                                { key: 'ZOOMIN', fr: 'Zoomer', en: 'Zoom In', win:{code: '=', shift: false, ctrl: true, alt: false}},
                                { key: 'ZOOMOUT', fr: 'Dézoomer', en: 'Zoom Out', win:{code: 'Digit6', shift: false, ctrl: true, alt: false}},
                                { key: 'ZOOMIN', fr: 'Zoomer', en: 'Zoom In', win:{code: '+', shift: false, ctrl: true, alt: false}},
                                { key: 'ZOOMOUT', fr: 'Dézoomer', en: 'Zoom Out', win:{code: '-', shift: false, ctrl: true, alt: false}},
                                { key: 'NOZOOM', fr: 'Zoom par défautr', en: 'Default Zoom', win:{code: 'Backspace', shift: false, ctrl: true, alt: false}},

                                { key: 'REFRESH', fr: 'Rafraichir le texte', en: 'Refresh text', win: { code: 'Refresh', shift: false, ctrl: false, alt: false } },
                                
                                { key: 'DISPLAYTABLECHAR', fr: 'Afficher la table des caractères', en: 'Display character table', win: { code: 'c', shift: false, ctrl: true, alt: true } },

                                { key: 'SUBMITWORD', fr: 'Valider le mot', en: 'Submit the word', win: {  code: 'Enter', shift: true, ctrl: false, alt: false, }},
                                
                                { key: 'SUBMITSENTENCE', fr: 'Valider la phrase jusqu’au point final', en: 'Submit the sentence until the dot', win: { code: 'Enter', shift: false, ctrl: true, alt: true }},
  
                                { key: 'SUBMITUNTILPUNCTUATION', fr: "Valider jusqu'à la prochaine ponctuation", en: 'Submit until the next punctuation', win: { code: 'Enter', shift: true, ctrl: true, alt: true }},
                                
                                { key: 'CANCELSUBMITWORDS', fr: 'Annuler tous les mots validés', en: 'Cancel all the submitted words', win: { code: 'Delete', shift: true, ctrl: true, alt: true }},

                            ]
                        },
                        {
                            fr: "TimeCode",
                            en: "TimeCode",
                            shortcuts:
                            [
                                { key: 'SETTCIN', fr: 'Définir le time code pour le début du mot', en: 'Define the time code for the beginning of the word', win:{code: '$', shift: false, ctrl: true, alt: false}},
                                { key: 'SETTCOUT', fr: 'Définir le time code pour la fin du mot', en: 'Define the time code for the end of the word', win:{code: '¤', shift: false, ctrl: true, alt: true}},
                            ]
                        },

                    ],
                },
                // ******************************* SUBTITLING
                {
                    name:"subtitling",
                    fr:"Sous-titrage", 
                    en:"Subtitling",
                    subfamily: 
                    [
                        {
                            fr: "Saisie des times codes",
                            en: "Time code input",
                            shortcuts:
                            [
                                { key: 'TAKEIN', fr: 'Capture time code In', en: 'Take In', win:{code: 'F1', shift: false, ctrl: false, alt: false}},
                                { key: 'TAKEOUT', fr: 'Capture time code Out', en: 'Take Out', win:{code: 'F2', shift: false, ctrl: false, alt: false}},
                                //{ key: 'TAKETIMECODEVIDEOTOINSUBTITLE', fr: "Prendre le time code de la vidéo et l'affecte au time code IN du sous-titre", en: 'Take the time code of the video and assign it to the time code IN the subtitle', win: { code: 'F1', shift: false, ctrl: false, alt: false } },
                                //{ key: 'TAKETIMECODEVIDEOTOOUTSUBTITLE', fr: "Prendre le time code de la vidéo et l'affecte au time code OUT du sous-titre", en: 'Take the time code of the video and assign it to the time code OUT the subtitle', win: { code: 'F2', shift: false, ctrl: false, alt: false }},
                                { key: 'TAKETIMECODEOUTFROMPREVSUBTITLETOINCURRENTSUBTITLE', fr: "Coller le sous-titre au sous-titre/changement de plan précédent", en: 'Stick the subtitle to the previous subtitle/scene change', win: { code: 'F1', shift: true, ctrl: true, alt: false } },
                                { key: 'TAKETIMECODEINFROMNEXTSUBTITLETOOUTCURRENTSUBTITLE', fr: "Coller le sous-titre au sous-titre/changement de plan suivant", en: 'Stick the subtitle to the next subtitle/scene change.', win: { code: 'F2', shift: true, ctrl: true, alt: false } },
                                { key: 'SETTIMECODEFROMCURRENTSUBTITLETOVIDEO', fr: "Cale la vidéo au time code IN ou OUT du sous-titre courant", en: 'Sets video to IN or OUT time code of current subtitle', win: { code: 'Enter', shift: false, ctrl: false, alt: true } },
                                { key: 'SETCURRENTSUBTITLEFROMTIMECODE', fr: "Appel le sous-titre le plus proche de la video", en: 'Call subtitle nearest the video player time code', win: { code: 'Enter', shift: false, ctrl: true, alt: false }},

                                { key: 'TIMECODEIN_1', fr: "Insérer le chiffre 1 dans le timecode IN du sous-titre", en: 'Insert number 1 in timecode IN du sous-titre', win: { code: '1', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_2', fr: "Insérer le chiffre 2 dans le timecode IN du sous-titre", en: 'Insert number 2 in timecode IN du sous-titre', win: { code: '2', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_3', fr: "Insérer le chiffre 3 dans le timecode IN du sous-titre", en: 'Insert number 3 in timecode IN du sous-titre', win: { code: '3', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_4', fr: "Insérer le chiffre 4 dans le timecode IN du sous-titre", en: 'Insert number 4 in timecode IN du sous-titre', win: { code: '4', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_5', fr: "Insérer le chiffre 5 dans le timecode IN du sous-titre", en: 'Insert number 5 in timecode IN du sous-titre', win: { code: '5', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_6', fr: "Insérer le chiffre 6 dans le timecode IN du sous-titre", en: 'Insert number 6 in timecode IN du sous-titre', win: { code: '6', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_7', fr: "Insérer le chiffre 7 dans le timecode IN du sous-titre", en: 'Insert number 7 in timecode IN du sous-titre', win: { code: '7', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_8', fr: "Insérer le chiffre 8 dans le timecode IN du sous-titre", en: 'Insert number 8 in timecode IN du sous-titre', win: { code: '8', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_9', fr: "Insérer le chiffre 9 dans le timecode IN du sous-titre", en: 'Insert number 9 in timecode IN du sous-titre', win: { code: '9', shift: false, ctrl: true, alt: false } },
                                { key: 'TIMECODEIN_0', fr: "Insérer le chiffre 0 dans le timecode IN du sous-titre", en: 'Insert number 0 in timecode IN du sous-titre', win: { code: '0', shift: false, ctrl: true, alt: false } },
                                
                                { key: 'TIMECODEOUT_1', fr: "Insérer le chiffre 1 dans le timecode OUT du sous-titre", en: 'Insert number 1 in timecode OUT du sous-titre', win: { code: '1', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_2', fr: "Insérer le chiffre 2 dans le timecode OUT du sous-titre", en: 'Insert number 2 in timecode OUT du sous-titre', win: { code: '2', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_3', fr: "Insérer le chiffre 3 dans le timecode OUT du sous-titre", en: 'Insert number 3 in timecode OUT du sous-titre', win: { code: '3', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_4', fr: "Insérer le chiffre 4 dans le timecode OUT du sous-titre", en: 'Insert number 4 in timecode OUT du sous-titre', win: { code: '4', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_5', fr: "Insérer le chiffre 5 dans le timecode OUT du sous-titre", en: 'Insert number 5 in timecode OUT du sous-titre', win: { code: '5', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_6', fr: "Insérer le chiffre 6 dans le timecode OUT du sous-titre", en: 'Insert number 6 in timecode OUT du sous-titre', win: { code: '6', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_7', fr: "Insérer le chiffre 7 dans le timecode OUT du sous-titre", en: 'Insert number 7 in timecode OUT du sous-titre', win: { code: '7', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_8', fr: "Insérer le chiffre 8 dans le timecode OUT du sous-titre", en: 'Insert number 8 in timecode OUT du sous-titre', win: { code: '8', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_9', fr: "Insérer le chiffre 9 dans le timecode OUT du sous-titre", en: 'Insert number 9 in timecode OUT du sous-titre', win: { code: '9', shift: false, ctrl: true, alt: true } },
                                { key: 'TIMECODEOUT_0', fr: "Insérer le chiffre 0 dans le timecode OUT du sous-titre", en: 'Insert number 0 in timecode OUT du sous-titre', win: { code: '0', shift: false, ctrl: true, alt: true }},
                          
                                { key: 'INCREASETIMECODEIN', fr: 'Augmenter le timecode IN du sous-titre', en: 'Increase subtitle timecode IN', win:{code: '+', shift: false, ctrl: true, alt: false}},
                                { key: 'DECREASETIMECODEIN', fr: 'Diminuer le timecode IN du sous-titre', en: 'Decrease subtitle timecode IN', win:{code: '-', shift: false, ctrl: true, alt: false}},
                                { key: 'INCREASETIMECODEOUT', fr: 'Augmenter le timecode OUT du sous-titre', en: 'Increase subtitle timecode OUT', win:{code: '+', shift: false, ctrl: true, alt: true}},
                                { key: 'DECREASETIMECODEOUT', fr: 'Diminuer le timecode OUT du sous-titre', en: 'Decrease subtitle timecode OUT', win:{code: '-', shift: false, ctrl: true, alt: true}},
                                { key: 'QUICKOFFSET', fr: 'Offset à partir du sous-titre', en: 'Offset from current subtitle', win:{code: 'w', shift: false, ctrl: true, alt: true}},
                            
                            ]
                        },
                        {
                            fr: "Déplacement dans le texte",
                            en: "movements in the text",
                            shortcuts:
                            [

                                { key: 'LEFT', fr: 'Curseur vers la gauche', en: 'Cursor Left', win:{code: 'ArrowLeft', shift: false, ctrl: false, alt: false}},
                                { key: 'RIGHT', fr: 'Curseur vers la droite', en: 'Cursor Right', win:{code: 'ArrowRight', shift: false, ctrl: false, alt: false}},
                                { key: 'UP', fr: 'Curseur vers le haut', en: 'Cursor Up', win:{code: 'ArrowUp', shift: false, ctrl: false, alt: false}},
                                { key: 'DOWN', fr: 'Curseur vers le bas', en: 'Cursor Down', win:{code: 'ArrowDown', shift: false, ctrl: false, alt: false}},


                                { key: 'NEXTWORD', fr: 'Mot suivant', en: 'Next Word', win:{code: 'ArrowRight', shift: false, ctrl: true, alt: false}},
                                { key: 'PREVIOUSWORD', fr: 'Mot précédent', en: 'Previous word', win: { code: 'ArrowLeft', shift: false, ctrl: true, alt: false } },
                                
                                { key: 'FIRSTSUBTITLE', fr: 'Premier sous-titre', en: 'First subtitle', win:{code: 'Home', shift: false, ctrl: true, alt: true}},
                                { key: 'LASTSUBTITLE', fr: 'Dernier sous-titre', en: 'Dernier subtitle', win:{code: 'End', shift: false, ctrl: true, alt: true}},

                                { key: 'STARTSUBTITLE', fr: 'Début du sous-titre', en: 'Subtitle Start', win:{code: 'Home', shift: false, ctrl: true, alt: false}},
                                { key: 'ENDSUBTITLE', fr: 'Fin du sous-titre', en: 'Subtitle End', win:{code: 'End', shift: false, ctrl: true, alt: false}},

                                { key: 'PGUP', fr: 'Sous-titre précédent', en: 'Previous subtitle', win:{code: 'PageUp', shift: false, ctrl: false, alt: false}},
                                { key: 'PGDOWN', fr: 'Sous-titre suivant', en: 'Next subtitle', win:{code: 'PageDown', shift: false, ctrl: false, alt: false}},

                                { key: 'STARTLINE', fr: 'Début de la ligne de sous-titre', en: 'Start of subtitle line', win:{code: 'Home', shift: false, ctrl: false, alt: false}},
                                { key: 'ENDLINE', fr: 'Fin de la ligne de sous-titre', en: 'End of subtitle line', win:{code: 'End', shift: false, ctrl: false, alt: false}},

                                { key: 'STARTWORD', fr: 'Début du mot', en: 'Start of word', win: { code: 'ArrowUp', shift: false, ctrl: true, alt: false }},
                                { key: 'ENDWORD', fr: 'Fin du mot', en: 'End of word',win: { code: 'ArrowDown', shift: false, ctrl: true, alt: false }},
                              ],
 
                              

                        },
                        {
                            fr: "Edition du texte",
                            en: "Text Edition",
                            shortcuts:
                            [
                                { key: 'BACKSPACE', fr: 'Effacement Arrière', en: 'Backspace', win:{code: 'Backspace', shift: false, ctrl: false, alt: false}},
                                { key: 'DELETE', fr: 'Supprimer caractère', en: 'Delete', win:{code: 'Delete', shift: false, ctrl: false, alt: false}},

                                { key: 'COPY', fr: 'Copier', en: 'Copy', win:{code: 'c', shift: false, ctrl: true, alt: false}},
                                { key: 'PASTE', fr: 'Coller', en: 'Paste', win:{code: 'v', shift: false, ctrl: true, alt: false}},
                                { key: 'CUT', fr: 'Couper', en: 'Cut', win:{code: 'x', shift: false, ctrl: true, alt: false}},
                                { key: 'UNDO', fr: 'Annuler', en: 'Undo', win:{code: 'z', shift: false, ctrl: true, alt: false}},
                                { key: 'REDO', fr: 'Refaire', en: 'Redo', win:{code: 'y', shift: false, ctrl: true, alt: false}},

                                { key: 'DELETEWORD', fr: 'Supprimer un mot', en: 'Delete Word', win:{code: 'Delete', shift: false, ctrl: true, alt: false}},
                                { key: 'DELETELINE', fr: 'Supprimer la ligne', en: 'Delete Line', win:{code: 'o', shift: false, ctrl: true, alt: false}},

                                { key: 'ENTER',  fr: 'Entrée',  en: 'Enter', win: { code: 'Enter', shift: false, ctrl: false, alt: false}},
                                { key: 'UNSECABLE',fr: 'Espace insécable', en: 'Unsecable space', win: { code: ' ',shift: true, ctrl: true, alt: false}},

                                { key: 'DELETEWORDSUNTIL',fr: "Suppression jusqu'au mot", en: 'Deletion until the word', win: { code: 'F12', shift: false, ctrl: false, alt: false }},
                                { key: 'DELETEUNSECABLE', fr: "Supprime l'espace insécable", en: 'Delete unsecable space', win: { code: '<', shift: false, ctrl: true, alt: true}},

                                { key: 'GROUPBYUNSECABLESPACEWITHNEXTWORD', fr: 'Regroupe le mot en cours avec le mot suivant par un espace insécable',en: 'Group the current word with the next word by unsecable space', win: { code: 'i', shift: false, ctrl: true, alt: false}},
                                { key: 'GROUPBYUNSECABLESPACEWITHPREVIOUSWORD', fr: 'Regroupe le mot en cours avec le mot précédent par un espace insécable', en: 'Group the current word with the previous word by unsecable space', win: { code: 'i', shift: false, ctrl: false, alt: true }},

                                { key: 'TAKEWORDFROMLASTSUBTITLETOCURRENTSUBTITLE', fr: 'Prendre le dernier mot du sous-titre précédent et le mettre au début du sous-titre en cours.', en: 'Take the last word of the previous subtitle and place it at the beginning of the current subtitle.', win: { code: '3', shift: true, ctrl: true, alt: false } },
                                { key: 'TAKEWORDFROMNEXTSUBTITLETOCURRENTSUBTITLE', fr: 'Prendre le premier mot du sous-titre suivant et le mettre à la fin du sous-titre en cours.', en:'Take the first word of the next subtitle and place it at the end of the current subtitle.', win: { code: '5', shift: true, ctrl: true, alt: false } },
                                { key: 'TAKEWORDFROMCURRENTSUBTITLETOPREVSUBTITLE', fr: 'Prendre le premier mot du sous-titre en cours et le mettre à la fin du sous-titre précédent.', en: 'Take the first word of the current subtitle and place it at the end of the previous subtitle.', win: { code: 'F3', shift: true, ctrl: true, alt: false } },
                                { key: 'TAKEWORDFROMCURRENTSUBTITLETONEXTSUBTITLE', fr: 'Prendre le dernier mot du sous-titre en cours et le mettre au début du sous-titre suivant.', en: 'Take the last word of the current subtitle and move it to the beginning of the next subtitle.', win: { code: 'F5', shift: true, ctrl: true, alt: false } },
                                
                                { key: 'ROTATEWORDTOUP', fr: 'Rotation du mot vers le haut', en: 'Rotate word to up', win: { code: 'F3', shift: false, ctrl: true, alt: false } },
                                { key: 'ROTATEWORDTODOWN', fr: 'Rotation du mot vers le bas', en: 'Rotate word to down', win: { code: 'F5', shift: false, ctrl: true, alt: false } },

                            ]

                        },

                        {
                            fr: "Corrections rapides",
                            en: "Quick Fix",
                            shortcuts:
                            [

                                { key: 'TAB',fr: 'Erreurs communes de transcription', en: 'Common transcription errors',win: { code: 'Tab',shift: false, ctrl: false, alt: false }},
                                { key: 'ADDHYPHEN',fr: 'Ajouter un tiret',en: 'Add a hyphen', win: { code: 'F1',shift: false, ctrl: true,alt: false}},
                                { key: 'GROUPWORDSWITHOUTSPACE',fr: 'Regroupe les mots sans espace',en: 'Group the words without space',win: { code: 'g',shift: false, ctrl: true, alt: false }},
                                { key: 'CONVERSIONTOINITIAL',  fr: 'Transformation en initiales', en: 'Conversion to initial',  win: { code: 'j', shift: false, ctrl: true, alt: false }},
                                { key: 'CONVERSIONTOINITIALWITHOUTSPACE', fr: 'Transformation en initiales sans espace', en: 'Conversion to initial without space', win: { code: 'j', shift: false, ctrl: true, alt: true }},
                                { key: 'UPPERCASEORLOWERCASEONFIRSTLETTER', fr: 'Majuscule/minuscule sur la première lettre',en: 'Upper/lower case on first letter', win: { code: 'q', shift: false, ctrl: true, alt: false }},
                                { key: 'UPPERCASEORLOWERCASEONSECONDLETTER', fr: 'Majuscule/minuscule sur la deuxième lettre', en: 'Upper/lower case on second letter', win: { code: 'Q', shift: true, ctrl: true, alt: false }},
                                { key: 'UPPERCASEORLOWERCASEWITHAPOSTROPHEORPERIOD', fr: 'Mettre une majuscule ou une minuscule aprÃ¨s une apostrophe ou un point', en: 'Upper or lower case after an apostrophe or a period', win: { code: 'Q', shift: true, ctrl: true, alt: true }},
                                { key: 'UPPERCASEORLOWERCASEWITHDASH', fr: 'Majuscule/minuscule mot avec un tiret', en: 'Upper/lower case on word with dash', win: { code: 'w', shift: false, ctrl: false, alt: true }},
                                { key: 'UPPERCASEONWORD', fr: 'Mot en majuscule', en: 'Uppercase on word', win: { code: 'u', shift: false, ctrl: true, alt: false }},
                                { key: 'LOWERCASEONWORD', fr: 'Mot en minuscule', en: 'Lowercase on word', win: { code: 'L', shift: true, ctrl: true, alt: false }},
                                { key: 'UPPERCASEORLOWERCASEONSENTENCE', fr: 'Sous-titre entier en majuscule ou en minuscule', en: 'Uppercase or lowercase on subtitle', win: { code: 'U', shift: true, ctrl: true, alt: false }},
                                { key: 'RETURNTOLINEWITHHYPHEN', fr: 'Retour à la ligne avec tiret', en: 'Return to line with hyphen', win: { code: '-', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDPERIOD', fr: 'Ajoute un point à la fin du mot',  en: 'Add a period at the end of the word', win: { code: 'p', shift: false, ctrl: true, alt: false }},
                                { key: 'ADDPERIODANDNEWLINE', fr: 'Ajoute un point à la fin du mot et nouvelle ligne', en: 'Add a period at the end of the word and new line', win: { code: 'P', shift: true, ctrl: true, alt: false }},
                                { key: 'ADDQUOTES', fr: 'Ajoute des guillemets', en: 'Add quotes', win: { code: 'm', shift: false, ctrl: true, alt: false }},
                                { key: 'ADDTWOAPOSTROPHES', fr: 'Ajoute des apostrophes au début et à la fin du mot', en: 'Add apostrophes at the beginning and end of the word', win: { code: 'm', shift: false, ctrl: true, alt: true}},
                                
                                { key: 'ADDONEAPOSTROPHE', fr: 'Ajoute un apostrophe au mot', en: 'Add one apostrophe to the word', win: { code: '4', shift: true, ctrl: true, alt: false }},
                                { key: 'ADDORREMOVESLETTER', fr: 'Ajoute ou enlève un s', en: 'Add or remove s letter',  win: { code: 's', shift: false, ctrl: true, alt: true }},
                                { key: 'ADDORREMOVENTLETTER',  fr: "Ajoute ou enlève un 'nt'", en: "Add or remove 'nt' letters", win: { code: 't', shift: false, ctrl: true, alt: true}},
                                { key: 'INVERTPERIODEANDCOMMA', fr: 'Inverse le point et la virgule', en: 'Invert the period and comma', win: { code: ';', shift: false, ctrl: false,  alt: true }},
                                { key: 'INVERTA', fr: 'Inverse le a et à', en: 'Invert the a and à', win: { code: 'a', shift: false, ctrl: false, alt: true }},
                                { key: 'HYPHENATETWOWORDS', fr: 'Regroupe deux mots par un tiret', en: 'Hyphenate two words', win: { code: 'd', shift: false, ctrl: true,alt: false }},
                                { key: 'REPLACEHYPHENWITHSPACE', fr: 'Remplace le tiret dans le mot par un espace', en: 'Replace the hyphen in the word with a space', win: { code: 'D', shift: true, ctrl: true, alt: false }},
                                { key: 'REPLACEHYPHENWITHUNSECABLESPACE', fr: 'Remplace le tiret dans le mot par un espace insécable', en: 'Replace the hyphen in the word with a unsecable space',win: { code: 'I', shift: true, ctrl: true, alt: false }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_C',fr: "Ajoute ou supprime la lettre c'",en: "Add or remove c' letter", win: { code: 'c',  shift: false, ctrl: false, alt: true}},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_C', fr: "Ajoute ou supprime l'apostrophe à la lettre c", en: 'Add or remove the apostrophe from the c letter', win: { code: 'C', shift: true, ctrl: false, alt: true}},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_D', fr: "Ajoute ou supprime la lettre d'", en: "Add or remove d' letter", win: { code: 'd', shift: false, ctrl: false, alt: true }},
                                
                                  // Ne marche pas, pourquoi ???
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_D', fr: "Ajoute ou supprime l'apostrophe à la lettre d", en: 'Add or remove the apostrophe from the d letter', win: { code: 'D', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_J', fr: "Ajoute ou supprime la lettre j'",en: "Add or remove j' letter", win: { code: 'j', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_J', fr: "Ajoute ou supprime l'apostrophe à la lettre j",en: 'Add or remove the apostrophe from the j letter', win: { code: 'J', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_L', fr: "Ajoute ou supprime la lettre l'", en: "Add or remove l' letter",win: { code: 'l', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_L', fr: "Ajoute ou supprime l'apostrophe à la lettre l", en: 'Add or remove the apostrophe from the l letter',win: { code: 'L', shift: true, ctrl: false, alt: true}},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_M', fr: "Ajoute ou supprime la lettre m'", en: "Add or remove m' letter", win: { code: 'm', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_M', fr: "Ajoute ou supprime l'apostrophe à la lettre m", en: 'Add or remove the apostrophe from the m letter', win: { code: 'M', shift: true, ctrl: false,  alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_N', fr: "Ajoute ou supprime la lettre n'", en: "Add or remove n' letter", win: { code: 'n', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_N', fr: "Ajoute ou supprime l'apostrophe à la lettre n", en: 'Add or remove the apostrophe from the n letter', win: { code: 'N', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_Q', fr: "Ajoute ou supprime la lettre qu'", en: "Add or remove qu' letter", win: { code: 'q', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_Q', fr: "Ajoute ou supprime l'apostrophe à la lettre qu", en: 'Add or remove the apostrophe from the qu letter', win: { code: 'Q', shift: true, ctrl: false, alt: true}},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_S', fr: "Ajoute ou supprime la lettre s'", en: "Add or remove s' letter", win: { code: 's', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_S', fr: "Ajoute ou supprime l'apostrophe à la lettre s", en: 'Add or remove the apostrophe from the s letter', win: { code: 'S', shift: true, ctrl: false, alt: true }},
                                { key: 'ADDORADDORREMOVEAPOSTROPHEWITHLETTER_T', fr: "Ajoute ou supprime la lettre T'", en: "Add or remove t' letter", win: { code: 't', shift: false, ctrl: false, alt: true }},
                                { key: 'ADDORREMOVEAPOSTROPHETOLETTER_T', fr: "Ajoute ou supprime l'apostrophe à la lettre t", en: 'Add or remove the apostrophe from the t letter', win: { code: 'T', shift: true, ctrl: false, alt: true }},
                                { key: 'REPLACE_E', fr: "Remplace 'er' => 'é'", en: "Replace 'er' => 'é'",  win: { code: 'e',  shift: false,  ctrl: false, alt: true }},
                                { key: 'REPLACE_Z', fr: "Remplace 'r' => 'z'",  en: "Replace 'r' => 'z'", win: { code: 'z', shift: false, ctrl: false, alt: true }},
                                { key: 'REPLACE_R', fr: "Remplace 'ez' => 'er'",en: "Replace 'ez' => 'er'", win: { code: 'r', shift: false, ctrl: false, alt: true }},
                                { key: 'REPLACE_T', fr: "Remplace 'é' => 'ait' => 'aient'", en: "Replace 'é' => 'ait' => 'aient'",  win: { code: 'T',  shift: true, ctrl: true,  alt: true }},
                                { key: 'ADDORREMOVELETOWORD',  fr: "Ajoute ou enlève à la fin du mot 'le'", en: "Add or remove at the end of the word 'le'", win: { code: 'l',shift: false, ctrl: true, alt: false }},
                            ]
                        },

                        {
                            fr: "Sélection des mots",
                            en: "Words selection",
                            shortcuts:
                            [
                                { key: 'SELECTLEFT', fr: 'Sélectionner un mot vers la gauche', en: 'Select to Left', win:{code: 'ArrowLeft', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTRIGHT', fr: 'Sélectionner un mot vers la droite', en: 'Select to Right', win:{code: 'ArrowRight', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTUP', fr: 'Sélectionner un mot vers le haut', en: 'Select to Up', win:{code: 'ArrowUp', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTDOWN', fr: 'Sélectionner un mot vers le bas', en: 'Select to Down', win:{code: 'ArrowDown', shift: true, ctrl: true, alt: false}},

                                { key: 'SELECTA', fr: 'Sélectionner un mot, la ligne ou le sous-titre et copie.', en: 'Select word, line or subtitle and copy', win:{code: 'a', shift: false, ctrl: true, alt: false}},

                                { key: 'SELECTUPSENTENCE', fr: "Sélectionner jusqu'au début du sous-titre", en: 'Select up to the beginning of the subtitle', win:{code: 'Home', shift: true, ctrl: true, alt: false}},
                                { key: 'SELECTDOWNSENTENCE', fr: "Sélectionner jsuqu'à la fin du sous-titre", en: 'Select up to the end of the subtitle', win:{code: 'End', shift: true, ctrl: true, alt: false}},

                                { key: 'SELECTLETTERBYLETTERONRIGHT', fr: 'Sélectionner lettre par lettre à droite', en: 'Select letter by letter on the right', win:{code: 'ArrowRight', shift:true, ctrl:false, alt:false}},
                                { key: 'SELECTLETTERBYLETTERONLEFT', fr: 'Sélectionner lettre par lettre à gauche', en: 'Select letter by letter on the left', win:{code: 'ArrowLeft', shift:true, ctrl:false, alt:false}}
                            ],
                        },

                        {
                            fr: "Déplacement des lignes",
                            en: "Lines placements",
                            shortcuts:
                            [
                                { key: 'MOVELEFT', fr: 'Déplacer vers la gauche', en: 'Move to Left', win:{code: 'ArrowLeft', shift: true, ctrl: false, alt: true}},
                                { key: 'MOVERIGHT', fr: 'Déplacer vers la droite', en: 'Move to Right', win:{code: 'ArrowRight', shift: true, ctrl: false, alt: true}},
                                { key: 'MOVEUP', fr: 'Déplacer vers le haut', en: 'Move to Up', win:{code: 'ArrowUp', shift: true, ctrl: false, alt: true}},
                                { key: 'MOVEDOWN', fr: 'Déplacer vers le bas', en: 'Move to Down', win:{code: 'ArrowDown', shift: true, ctrl: false, alt: true}},
                                { key: 'SETDIALOG', fr: 'Dialogue', en: 'Dialog', win:{code: 'd', shift: false, ctrl: true, alt: true}},


                                { key: 'MOVESUBTITLETOLEFT', fr: 'Caler la ligne de sous-titre à gauche', en: 'Align the line to the left.', win:{code: 'G', shift: true, ctrl: true, alt: false}},
                                { key: 'MOVESUBTITLETORIGHT', fr: 'Caler la ligne de sous-titre à droite', en: 'Align the line to the right.', win:{code: 'D', shift: true, ctrl: true, alt: false}},
                                { key: 'MOVESUBTITLETOCENTER', fr: 'Centrer la ligne', en: 'Center the line', win:{code: 'C', shift: true, ctrl: true, alt: false}},


                            ]
                        },

                        {
                            fr: "Couleurs",
                            en: "Colors",
                            shortcuts: 
                            [
                                { key: 'BLUE', fr: 'Bleu', en: 'Blue', win:{code: 'F1', shift: true, ctrl: false, alt: false}},
                                { key: 'GREEN', fr: 'Vert', en: 'Green', win:{code: 'F2', shift: true, ctrl: false, alt: false}},
                                { key: 'CYAN', fr: 'Cyan', en: 'Cyan', win:{code: 'F3', shift: true, ctrl: false, alt: false}},
                                { key: 'RED', fr: 'Rouge', en: 'Red', win:{code: 'F4', shift: true, ctrl: false, alt: false}},
                                { key: 'MAGENTA', fr: 'Magenta', en: 'Magenta', win:{code: 'F5', shift: true, ctrl: false, alt: false}},
                                { key: 'YELLOW', fr: 'Jaune', en: 'Yellow', win:{code: 'F6', shift: true, ctrl: false, alt: false}},
                                { key: 'WHITE', fr: 'Blanc', en: 'White', win:{code: 'F7', shift: true, ctrl: false, alt: false}},
                            ]
                        },
                        {
                            fr: "Orthographe/Grammaire",
                            en: "Spelling/Grammar",
                            shortcuts:
                            [
                                { key: 'WORDCHECKER', fr: 'Verifier Orthographe/Grammaire', en: 'Check Spelling/Grammar', win:{code: 'F8', shift: true, ctrl: false, alt: false}},
                                { key: 'GOTOWORDINERROR', fr: 'Aller au prochain mot en erreur', en: 'Go to the next word in error', win:{code: 'E', shift: true, ctrl: true, alt: false}},
                            ]
                        },

                        {
                            fr: "Divers",
                            en: "Miscellianous",
                            shortcuts:
                            [
                                { key: 'SAVE', fr: 'Sauvegarder', en: 'Save', win:{code: 's', shift: false, ctrl: true, alt: false}},

                                { key: 'SEARCH', fr: 'Rechercher', en: 'Search', win:{code: 'f', shift: false, ctrl: true, alt: false}},
                                { key: 'REPLACE', fr: 'Remplacer', en: 'Replace', win:{code: 'h', shift: false, ctrl: true, alt: false}},
                                { key: 'NEXTMATCH', fr: 'Correspondance suivante', en: 'Next match', win:{code: 'F3', shift: false, ctrl: false, alt: false}},
                                { key: 'PREVIOUSMATCH', fr: 'Correspondance précédente', en: 'Previous match', win:{code: 'F4', shift: false, ctrl: false, alt: false}},

                              { key: 'DELETESUBTITLE', fr: 'Supprimer un sous-titre', en: 'Delete subtitle', win: { code: 'Delete', shift: false, ctrl: false, alt: true }},
                                { key: 'INSERTSUBTITLEAFTERCURRENTSUBTITLE', fr: 'Insérer un nouveau sous-titre après le sous-titre en cours', en: 'Insert a new subtitle after the current subtitle', win: { code: 'Insert', shift: false, ctrl: false, alt: true } },
                              { key: 'INSERTSUBTITLEBEFORECURRENTSUBTITLE', fr: 'Insérer un nouveau sous-titre avant le sous-titre en cours', en: 'Add new subtitle before the current subtitle', win: { code: 'Insert', shift: false, ctrl: true, alt: true }},

                                { key: "PLAYMODECONCE", fr: "Mode simulation", en: "Simulation mode", win: { code: "F6", shift: false, ctrl: false, alt: false } },
                              
                                { key: 'CUTASUBTITLE', fr: "Découpe d’un sous-titre", en: "Cutting a subtitle", win: { code: 'p', shift: false, ctrl: false, alt: true } },
                                { key: 'REGROUPSUBTITLE', fr: "Regroupe le sous-titre en cours avec le suivant.", en: "Regrouping the current subtitle with the next one.", win: { code: '=', shift: false, ctrl: false, alt: true } },

                                { key: 'DISPLAYTABLECHAR', fr: 'Afficher la table des caractères', en: 'Display character table', win: { code: 'c', shift: false, ctrl: true, alt: true } },
                                
                                { key: 'SHOWORHIDESUBTITLENUMBER', fr: 'Afficher ou cacher le numéro de sous-titre', en: 'Show or hide the subtitle number', win: { code: 'b', shift: false, ctrl: false, alt: true } },
                                
                                { key: 'GOTOSUBTITLENUMBER', fr: 'Aller au sous-titre n°', en: 'Go to subtitle number', win: { code: 'g', shift: false, ctrl: false, alt: true } },
                                
                                { key: 'CHANGESUBTITLE',fr: 'Changer de sous-titres (originaux/modifiés)',en: 'Change subtitles (original/corrected', win: { code: 'Tab', shift: true,ctrl: false, alt: false}},

                                {key: 'SETLISIBILITY', fr: 'Appliquer la lisibilité sur tous les sous-titres', en: 'Apply lisibility to all subtitles', win: { code: 'L', shift: true,ctrl: false, alt: true}},

                                {key: 'CHANGELINEHEIGHT', fr: 'Changer la hauteur de la ligne', en: 'Change the line height', win: { code: 'F11', shift: false,ctrl: false, alt: false}}
                              
                              ]
                        },
                        {
                            fr:"Mode",
                            en:"Mode",
                            shortcuts:
                            [
                                { key: 'MODEA', fr: 'Faire suivre la vidéo au sous-titre', en: 'Lock video to subtitle', win:{code: '/', shift: true, ctrl: false, alt: false}},
                                { key: 'MODEB', fr: 'Faire suivre les sous-titres à la vidéo', en: 'Lock subtitle to video', win:{code: '*', shift: true, ctrl: false, alt: false}},
                                { key: 'MODEC', fr: 'Simulation en play', en: 'Simulation when play', win:{code: '-', shift: true, ctrl: false, alt: false}},

                            ]

                        }

                    ],
                },


                // ******************************* VOICE OVER
                {
                    name:"voiceover",
                    fr:"Voiceover / audio description", 
                    en:"Voiceover / audio description",
                    unique: false,
                    subfamily: 
                    [
                        {
                            fr: "Déplacement dans le texte",
                            en: "movements in the text",
                            shortcuts:
                            [
                            ]
                        },
                    ],
                },


            ],


        };


//  ************************************************************************************************************************************************
//  * test de validité de la liste des shortcuts
//  ************************************************************************************************************************************************
function keyboard_multi_checkShortcutsList(liste)
{
    if (Array.isArray(liste.applications)) {
        

        liste.applications.forEach ((family,index) =>  {
          var present = ( ['fr','en','name', 'subfamily'].every (key => key in family))
          if (!present)
          {
              alert ("Bug dans shortcuts (family index " + index.toString() +")");
              return false;
          }
          else
          {
              
              if (Array.isArray(family.subfamily)) {
                // test intégrite subfamily
                family.subfamily.forEach((subfamily, sindex) => {
                  present = ( ['fr','en', 'shortcuts'].every (key => key in subfamily))
                  if (!present)
                  {
                    alert ("Bug dans shortcuts (family index " + index.toString() +" subfamily "+sindex.toString()+")");
                    return false;

                  }
                  else
                  {
                      if (Array.isArray(subfamily.shortcuts)) 
                      {
                          // test sur short cut intégrity dans 
                          subfamily.shortcuts.forEach((shortcut, ssindex) => {
                            present = ( ['fr','en', 'key', 'win'].every (key => key in shortcut)) // mac est optionnel
                            if (!present)
                            {
                              alert ("Bug dans shortcuts (family index " + index.toString() +" subfamily "+sindex.toString()+" shortcut "+ssindex.toString()+")");
                              return false;

                            }
                            else
                            {
                                // on a plus qu'a tester win....
                                present = ( ['code','shift', 'ctrl', 'alt'].every (key => key in shortcut.win)) // mac est optionnel
                                if (!present)
                                {
                                  alert ("Bug dans shortcuts win (family index " + index.toString() +" subfamily "+sindex.toString()+" shortcut "+ssindex.toString()+")");
                                  return false;
                                }
                                // on regarde si la structure mac si elle existe est valide
                                if ('mac' in shortcut)
                                {
                                    present = ( ['code','shift', 'ctrl', 'alt'].every (key => key in shortcut.mac)) // mac est optionnel
                                    if (!present)
                                    {
                                      alert ("Bug dans shortcuts mac (family index " + index.toString() +" subfamily "+sindex.toString()+" shortcut "+ssindex.toString()+")");
                                      return false;
                                    }
                                }
                            }
                          });
                      }
                      else
                        alert ("Bug dans shortcuts (shortcuts) "+family.fr+" "+subfamily.fr)
                  }
                })
              }
              else  
              {
                alert ("Bug dans shortcuts (subfamily)")
              }
          }

        })
        
        return true;
    }
    else
    { 
        alert ("Bug dans shortcuts (family)")
        return false;
    }    
  }

//  ************************************************************************************************************************************************
//  * lecture de la liste des raccourcis apps (array)= applications ex: ["player","transcription","subtitling"]
//  ************************************************************************************************************************************************

export function keyboard_multi_getShorCutList()
{
   
    var liste = getCurrentShortcutsList();
    var usedefaultlist = false;
    
    if (!liste)
    {
      liste = structuredClone(defaultsShortCuts);
      usedefaultlist = true;
    }
    else
    {
        try
        {
          liste = JSON.parse(liste);
          
        }
        catch (e)
        {
          liste = structuredClone(defaultsShortCuts);
          usedefaultlist = true;
        }
    }
      
    

    if (!keyboard_multi_checkShortcutsList(liste))
    {
        if (usedefaultlist) // gros bug
        {
          alert("BUG sur defaultsShortCuts");
          liste = null;
        }
        else
        {
          liste = structuredClone(defaultsShortCuts);
          if (!keyboard_multi_checkShortcutsList(liste))
          {
            liste = null;
            alert("BUG sur defaultsShortCuts");
          }
        }
    }
    return liste;



}

export function keyboard_multi_getShorCutList_by_apps_and_keyboard(apps)        
{
    var liste = keyboard_multi_getShorCutList(); // on recupère la liste complete des shortcuts
    // on crait maintenant une nouvelle liste reduite aux applications compatible avec l'ancienne définition de touches
    //  {  app: 'xxxxx' key: 'xxxx', fr: 'xxxxxx' , en: 'xxxxx', code:'xxxxx', shift: bool, ctrl: bool, alt: bool }
    // a partir de {key:"PLAY", fr:"Play/Stop",en:"Play/Stop", win:{code: "ArrowUp", shift:false,ctrl:false,alt:true}, mac:{code: "ArrowUp", shift:false,ctrl:false,alt:true}},
    

    var finalList = [];
    if (!liste) return finalList;

    const currentKeyboard = getCurrentKeyboard();

    liste.applications.forEach ((application, appindex) => {
      if (apps.includes(application.name))
      {
        application.subfamily.forEach ((subfamily, sindex) => {
          subfamily.shortcuts.forEach ((shortcut, sssindex) => {


            var code = shortcut.win.code;
            var shift = shortcut.win.shift;
            var ctrl = shortcut.win.ctrl;
            var alt = shortcut.win.alt;


            if (currentKeyboard === 1) // mac ?
            {
              if ('mac' in shortcut)
              {
                  code = shortcut.mac.code;
                  shift = shortcut.mac.shift;
                  ctrl = shortcut.mac.ctrl;
                  alt = shortcut.mac.alt;

              }
            }

            const oneshortcut = {
              application: application.name,
              key: shortcut.key,
              fr: shortcut.fr,
              en: shortcut.en,
              code: code,
              shift: shift,
              ctrl: ctrl,
              alt: alt,
            }

            finalList.push(oneshortcut);

          });

        });

      }
    });
    return finalList;
}

        
//  ***********************************************************************************************************************
//  * recherche d'un raccourci
//  ***********************************************************************************************************************


export function keyboard_multi_getKey(app, shortcuts ,code, shift, ctrl, alt)
{

    if (code )
    {
        for (var i=0; i< shortcuts.length; i++)
        {

            var codelow = code;
            if ((code >="A") && (code <="Z")) codelow = code.toLowerCase();

            if (
                (app === shortcuts[i].application) &&
                (codelow == shortcuts[i].code.toLowerCase()) &&
                (shift === shortcuts[i].shift) &&
                (ctrl === shortcuts[i].ctrl) &&
                (alt === shortcuts[i].alt)
            )
                return shortcuts[i].key;
        
        }
    }
    return "";

}


//  ***********************************************************************************************************************
//  * function pour la programmation des touches
//  ***********************************************************************************************************************
export function keyboard_multi_getPersonnalKey(defaultValue = false)
{

    var liste = liste = structuredClone(defaultsShortCuts);
    if (!defaultValue)
        var liste = keyboard_multi_getShorCutList();
    
    if (!liste) return liste;
    const currentKeyboard = getCurrentKeyboard();
    liste.applications.forEach ((application, sindex) => {
    application.subfamily.forEach ((subfamily, sindex) => {
      subfamily.shortcuts.forEach ((shortcut, sssindex) => {
        var code = shortcut.win.code;
        var shift = shortcut.win.shift;
        var ctrl = shortcut.win.ctrl;
        var alt = shortcut.win.alt;

        if (currentKeyboard === 1) // mac ?
        {
          if ('mac' in shortcut)
          {
              code = shortcut.mac.code;
              shift = shortcut.mac.shift;
              ctrl = shortcut.mac.ctrl;
              alt = shortcut.mac.alt;

          }
        }
        shortcut.current = { code: code, shift: shift,  ctrl: ctrl, alt: alt};
      });
    });
    });


    return liste;
}



export function keyboard_multi_savePersonnalKey(liste)
{
    if (!liste) return liste;
    const currentKeyboard = getCurrentKeyboard();
    liste.applications.forEach ((application, sindex) => {
        application.subfamily.forEach ((subfamily, sindex) => {
          subfamily.shortcuts.forEach ((shortcut, sssindex) => {
            var code = shortcut.current.code;
            var shift = shortcut.current.shift;
            var ctrl = shortcut.current.ctrl;
            var alt = shortcut.current.alt;

            if (currentKeyboard === 1) // mac ?
            {
                shortcut.mac.code = code;
                shortcut.mac.shift = shift;
                shortcut.mac.ctrl = ctrl;
                shortcut.mac.alt = alt;
            }
            else
            {
                shortcut.win.code = code;
                shortcut.win.shift = shift;
                shortcut.win.ctrl = ctrl;
                shortcut.win.alt = alt;
            }

            delete shortcut.current;
            
          });
        });
    });

    setCurrentShortcutsList(JSON.stringify(liste));
}


export function keyboard_jsonToCsv(json, lang = "fr") {
    // Vérification de la langue

    const rows = [];

    // Ligne de titre
    rows.push([
        "Application",
        "Family",
        "Description",
        "Code",
        "Shift",
        "Ctrl",
        "Alt"
    ]);

    // Parcours des applications
    for (const application of json.applications || []) {

        const applicationName = application.name || "";

        // Parcours des sous-familles
        for (const subfamily of application.subfamily || []) {

            const subfamilyName = subfamily[lang] || "";

            // Parcours des shortcuts
            for (const shortcut of subfamily.shortcuts || []) {

                const current = shortcut.current || {};

                rows.push([
                    applicationName,
                    subfamilyName,
                    shortcut[lang] || "",
                    current.code || "",
                    current.shift ?? false,
                    current.ctrl ?? false,
                    current.alt ?? false
                ]);
            }
        }
    }

    // Conversion en CSV
    return rows
        .map(row => row.map(value => csvEscape(value)).join(","))
        .join("\r\n");
}


// Protège les valeurs CSV contenant virgules, guillemets ou retours à la ligne
function csvEscape(value) {
    value = String(value ?? "");

    if (
        value.includes(",") ||
        value.includes('"') ||
        value.includes("\n") ||
        value.includes("\r")
    ) {
        return '"' + value.replace(/"/g, '""') + '"';
    }

    return value;
}



